<ul class="layout-menu">
    <div class="px-5 py-2" *ngIf="currentUserInfo">
        <span class="mb-2 font-semibold" *ngIf="currentUserInfo">Logged As: {{ currentUserInfo.email }}</span>
    </div>
    <ng-container *ngFor="let item of menuItems; let i = index">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
